// extracted by mini-css-extract-plugin
export default {"buttons":"single-course_buttons__s5W93"};